import React, { useState, useEffect } from 'react';
import { X, Plus, MousePointer2, Layers, Keyboard, Eye } from 'lucide-react';
import { Button } from '../ui/button';

const STORAGE_KEY = 'canvas_onboarding_seen';

const STEPS = [
  {
    icon: Plus,
    title: 'Add Elements',
    description: 'Use the layers panel or toolbar to add text, images, and shapes to your design.',
  },
  {
    icon: MousePointer2,
    title: 'Edit Properties',
    description: 'Click any element to select it, then use the right panel to customize its appearance.',
  },
  {
    icon: Layers,
    title: 'Manage Layers',
    description: 'Drag layers to reorder, toggle visibility, or lock elements in place.',
  },
  {
    icon: Keyboard,
    title: 'Keyboard Shortcuts',
    description: 'Ctrl+Z to undo, Ctrl+D to duplicate, Delete to remove, Arrow keys to nudge.',
  },
  {
    icon: Eye,
    title: 'Preview & Export',
    description: 'Preview your design with real product data, then render or export when ready.',
  },
];

export function CanvasOnboarding() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(STORAGE_KEY);
    if (!seen) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-background rounded-2xl shadow-2xl border max-w-md w-full mx-4 p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">Welcome to the Canvas Editor</h2>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={handleDismiss}>
            <X className="h-4 w-4" />
          </Button>
        </div>

        <div className="space-y-3 mb-6">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <div key={i} className="flex items-start gap-3">
                <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10 shrink-0 mt-0.5">
                  <Icon className="h-4 w-4 text-primary" />
                </div>
                <div>
                  <p className="text-sm font-medium">{step.title}</p>
                  <p className="text-xs text-muted-foreground">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        <Button className="w-full rounded-lg" onClick={handleDismiss}>
          Got it, let's go!
        </Button>
      </div>
    </div>
  );
}
